import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { get_automation_portal_url } from '@/utils/urls.ts';
import { AUTOMATION_PORTAL_KEY } from '@/utils/queryKeys.ts';
import { AutomationPortal } from '@/types/automations.ts';

const useRetrieveAutomationPortal = (automationId?: string) => {
  const apiClient = useApiClient();

  return useQuery<AutomationPortal, AxiosError>({
    queryKey: AUTOMATION_PORTAL_KEY(automationId || ''),
    queryFn: async () => {
      const response = await apiClient.get(get_automation_portal_url(automationId));
      return response.data;
    },
    enabled: !!automationId,
  });
};

export default useRetrieveAutomationPortal;
